import OnboardingTutorial from './components/OnboardingTutorial.js';
import connect from './connect';
import './assets/OnboardingTutorial.css';

export default connect(OnboardingTutorial);



// WEBPACK FOOTER //
// ./src/routes/OnboardingTutorial/index.js